import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { NotificacionComponent } from '@shared/ui/notificacion/notificacion.component';
import { DataNotificacion } from '@shared/ui/notificacion/interfaces/data.notificacion';
import { TypeAlertEnum } from '@shared/enums/type.alert.enum';

/**
 * Servicio que permite mostrar una notificación personalizada
 *
 * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
 */
@Injectable({
  providedIn: 'root'
})
export class NotificacionService {

  // Inyecciones de dependencias
  private _snackBar = inject(MatSnackBar);

  /**
   * Método que muestra la notificación, con la configuración recibida por parámetro
   *
   * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
   * @returns Referencia a la notificación abierta
   */
  open(dataAlertMensaje: DataNotificacion): MatSnackBarRef<NotificacionComponent> {
    return this._snackBar.openFromComponent(NotificacionComponent, {
      data: dataAlertMensaje,
      panelClass: ['custom-snackbar-container', 'm-t-120', 'm-r-32'],
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  /**
   * Remueve la actual notificación
   *
   * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
   */
  dismiss(): void {
    this._snackBar.dismiss();
  }

    /**
     * Muestra una notificación simple utilizando la configuración básica (tipo de alerta y mensaje).
     *
     * @param label Mensaje a mostrar en el tooltip
     * @param typeAlertEnum Tipo de alerta
     * @param duration Duración en milisegundo para ser cerrado automáticamente (Opcional)
     *
     * @author parias
     */
    public mostrarNotificacionBasica(label: string, typeAlertEnum: TypeAlertEnum, duration:number | null = null): void {
        this.open({typeAlertEnum,label});

        //Si se proporciona una duración, la notificación se cerrará automáticamente después de ese tiempo.
        if(duration){setTimeout(() => {this._snackBar.dismiss()}, duration); }
    }

}
